import { Injectable } from '@angular/core';
import {
  FrontendApiUpdateVerificationFlowRequest,
  VerificationFlow
} from '@ory/client';
import { Observable } from 'rxjs';
import { OryCreateInput, OryExecuteInput, OryExecuteOutput, OryGetInput, OryGetOutput } from '../../model';
import { OryKratosBaseFlow } from './base.flow';
import { OryFlowReader } from '../../utils';
import type {
  OryCreatableFlow,
  OryRetrievableFlow,
  OryExecutableFlow,
} from '../flow-capabilities';

/**
 * Implements Ory Kratos verification flow for email/phone verification.
 *
 * Supports verification methods:
 * - Email verification via link or code
 * - Phone verification via code
 *
 * Used after registration or when updating email/phone in settings.
 */
@Injectable({
  providedIn: 'root'
})
export class OryVerificationFlow
  extends OryKratosBaseFlow
  implements
    OryCreatableFlow<'verification'>,
    OryRetrievableFlow<'verification'>,
    OryExecutableFlow<'verification'>
{
  create(
    input: OryCreateInput<'verification'> = {},
  ): Observable<VerificationFlow> {
    return this.fromOryRequest(this.iamApi.createBrowserVerificationFlow(input));
  }

  get(input: OryGetInput<'verification'>): Observable<VerificationFlow> {
    return this.fromOryRequest(
      this.iamApi.getVerificationFlow(input),
    );
  }

  execute(
    flow: OryGetOutput<'verification'>,
    input: OryExecuteInput<'verification'>,
  ): Observable<OryExecuteOutput<'verification'>> {
    const csrfToken = OryFlowReader.csrfToken(flow)
    const apiRequest: FrontendApiUpdateVerificationFlowRequest = {
      flow: flow.id,
      updateVerificationFlowBody: {
        ...input,
        csrf_token: csrfToken
      }
    };

    return this.fromOryRequest(this.iamApi.updateVerificationFlow(apiRequest));
  }

}
